import {
    LOGS_SAGA_GET_LOKET_LOGS,
} from '../actionTypes'

export const getLoketLogs = () => ({
    type: LOGS_SAGA_GET_LOKET_LOGS,
})
